import React from 'react'
import { connect  } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Loading } from '@brainstud/react-helpers'

const LoadingWrapper = props => {
  if(!props.account.isLoggedIn) {
    if(props.component) {
      return props.component
    }

    return <Loading message={props.account.error} />
  }

  return props.children
}

export default withRouter(connect(
  (state) => ({
    account: state.account,
  }),
  null,
)(LoadingWrapper))
